var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0v32h32V0z",
    fill: "#F7DF1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.496 25c.645 1.053 1.483 1.826 2.966 1.826 1.246 0 2.042-.623 2.042-1.483 0-1.031-.818-1.396-2.19-1.996l-.75-.323c-2.17-.924-3.612-2.082-3.612-4.53 0-2.256 1.718-3.973 4.404-3.973 1.911 0 3.286.666 4.276 2.408l-2.341 1.504c-.516-.925-1.072-1.289-1.935-1.289-.881 0-1.44.559-1.44 1.289 0 .902.56 1.267 1.85 1.826l.751.322c2.555 1.095 3.998 2.212 3.998 4.724 0 2.707-2.127 4.19-4.983 4.19-2.793 0-4.597-1.33-5.48-3.075L21.496 25zm-10.623.26c.473.839.902 1.547 1.936 1.547.988 0 1.61-.386 1.61-1.89V14.694h3.008V24.96c0 3.113-1.826 4.53-4.49 4.53-2.408 0-3.802-1.246-4.511-2.746l2.447-1.482z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.d2d4bae7ec386d0513c82369cb924e44.svg";
export { ForwardRef as ReactComponent };